import React from 'react';
import {
    Box,
    TableCell,
    TableRow,
    Typography,
    makeStyles,
    Theme,
    Fade,
} from '@material-ui/core';
import { ITextRow } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    fontWeightMedium: {
        fontWeight: 500,
        backgroundColor: theme.palette.background.paper,
        width: 100,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
    },
    typography: {
        display: 'inline-block',
    },
}));

export const TextRow = ({ item, loading, ...props }: ITextRow) => {
    const classes = useStyles();

    return (
        <TableRow {...props}>
            <TableCell className={classes.fontWeightMedium}>
                {item.header}
            </TableCell>
            <Fade in={!loading} timeout={600}>
                <TableCell className={classes.paper}>
                    <Box display="flex" alignItems="center">
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            className={classes.typography}
                        >
                            {item.text || '- - -'}
                        </Typography>
                    </Box>
                </TableCell>
            </Fade>
        </TableRow>
    );
};
